<script lang="ts" setup>
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SearchBox from '@/views/search/SearchBox.vue';
import SearchFilters from '@/views/search/SearchFilters.vue';
import { Constants } from '@/utilities/constants.ts';

const { t } = useI18n();

const route = useRoute();
const showSearch = computed(() => route.name !== 'home' && route.name !== 'ad-unit' && route.name !== 'project');
</script>

<template>
  <header>
    <nav class="xs:px-3 mx-auto my-6 max-w-7xl px-4 md:px-5 lg:px-6 xl:my-5 xl:px-7 2xl:px-8">
      <div class="flex justify-between">
        <RouterLink :title="t('global.site-name')" class="focus:outline-ph-green-600 -ml-1 rounded-md p-1.5 focus:outline-2 focus:outline-offset-2" to="/">
          <img :alt="t('global.site-name')" :src="`${Constants.CdnBaseUrl}/public/${t('global.logo')}`" class="h-8 w-[185px]" fetchpriority="high" height="32" loading="eager" width="185" />
        </RouterLink>
        <LanguageSwitcher />
      </div>
      <div v-if="showSearch" class="no-print mt-2 flex justify-between space-x-3 border-y border-gray-200 py-2">
        <SearchBox class="mt-0.5 flex-1" />
        <SearchFilters />
      </div>
    </nav>
  </header>
</template>

<style lang="css" scoped></style>
